import React from 'react';
import {Formik, FieldArray, Form} from 'formik';
import {objectId} from 'shared/utils';
import Label from 'shared/components/label';
import TextButton from 'src/components/TextButton';
import FormButton from 'src/components/button';
import Icon from 'shared/components/icon';
import {CollegeCampusFormInstitution} from '../CollegeCampusForm';
import {useDispatch} from 'react-redux';
import {submitForm} from 'src/redux/admin/actions/communityCollegeSearch';
import FormikTextInput from 'src/components/inputs/formik-text-input';

interface Props {
  initialValues: CollegeCampusFormInstitution;
  setInstitution: (college: CollegeCampusFormInstitution) => void;
}

const CollegeForm = ({initialValues, setInstitution}: Props) => {
  const dispatch = useDispatch();
  return (
    <div className="college-campus-container">
      <div className="content">
        <Formik
          initialValues={initialValues}
          onSubmit={async (values) => {
            await dispatch(submitForm(values));
            setInstitution(values);
          }}
        >
          {({values, isValid, isSubmitting, dirty}) => (
            <Form>
              <div className="title campus-title">{values.name}</div>
              <div>
                {values.city}, {values.state}
              </div>
              <div>IPEDS ID #{values.unitId}</div>

              <div className="add-campuses-title">Add Campuses</div>
              <div className="notice">
                <Icon iconType="info-circle-r" className="notice-icon" />
                <div>
                  To remove a campus after it has been published, please reach out to a PM who can
                  prioritize the engineering task.
                </div>
              </div>

              <FieldArray name="campuses">
                {({remove, push}) => (
                  <>
                    {values.campuses &&
                      values.campuses.length > 0 &&
                      values.campuses.map((campus, i) => (
                        <Label key={campus._id || i} required>
                          {`Campus ${i + 1}`}
                          <div className="campus-fields">
                            <FormikTextInput
                              name={`campuses.${i}.name`}
                              required
                              placeholder="Campus name..."
                            />
                            {campus.isNew && (
                              <div className="student-count">
                                <TextButton onClick={() => remove(i)}>
                                  <Icon iconType="times-r" />
                                </TextButton>
                              </div>
                            )}
                          </div>
                        </Label>
                      ))}
                    <div className="add-campus">
                      <FormButton
                        color="primary"
                        type="button"
                        outline
                        margin={false}
                        onClick={() => push({_id: objectId(), name: '', isNew: true})}
                      >
                        + Add another campus
                      </FormButton>
                    </div>
                  </>
                )}
              </FieldArray>

              <div className="required-field-notice">* Indicates required field</div>

              <div className="publish">
                <FormButton disabled={!isValid || isSubmitting || !dirty} type="submit">
                  Publish to production
                </FormButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CollegeForm;
